export default __webpack_public_path__ + "static/loader-a1a996746e5e48352c8111e2c01e698c.gif";